<template>
    <b-modal
        id="checkoutModal"
        v-model="showModal"
        size="xxl"
        ok-variant="success"
        ok-title="Confirmă"
        cancel-variant="danger"
        cancel-title="Anulează"
        header-bg-variant="dark"
        body-bg-variant="dark custom-height"
        hide-footer
        hide-header
        centered
        @hide="$emit('hideTempModal');onHide($event)"
    >

        <div class="modal-body custom-modal-class">
            <div class="close-button" @click="$emit('hideTempModal')">X</div>
            <div v-if="!consultantForm" class="full-width">
                <div class="modal-header">
                    <h2>Felicitări!</h2>
                    <h3>Compania interogată este eligibilă pentru o finanțare prin POC Acțiunea 4.1.1 Investiții în
                        activități productive</h3>
                    <h2>începe să scrii proiectul tău, gratuit!</h2>
                </div>
                <div class="flex space-between sketch-info">
                    <img src="@/assets/images/M3/M3Sketch/poc_sketch_wide.png" alt="POC Sketch" class="sketch-logo info-sketch">
                    <div class="flex info-sketch align-items-center">
                        <span class="number">{{ dataStatus ? dataStatus.companii : 0 }}</span>
                        <p>proiecte în curs de scriere acum</p>
                    </div>
                    <a href="https://www.youtube.com/watch?v=iLZzc_KfvcE&t=1s&ab_channel=SMISRomania" target="_blank"
                       class="flex info-sketch align-items-center"
                    >
                        <img src="@/assets/images/M3/M3Sketch/play-gradient.png" alt="Smis">
                        <p>vezi prezentarea video a funcțiilor aplicației</p>
                    </a>
                </div>
            </div>
            <div v-else class="consultant-form">
                <div class="modal-header align-left">
                    <h2 class="m-0">Trimite cerere de ofertă</h2>
                </div>
                <validation-observer #default="{ invalid }" ref="observer">
                    <span class="display-none">{{ invalid }}</span>
                    <b-form class="mb-3 mt-2">
                        <div class="justify-content-end flex mb-3 mobile-column">
                            <div class="number-info">
                                <span class="number">{{ dataStatus ? dataStatus.consultanti : 0 }}</span>
                                <div class="flex flex-column flex-start">
                                    <p>Companii de consultanță înscrise</p>
                                    <a href="https://smis.ro/finantari/cauta-consultant" target="_blank" class="purple-text">ÎNSCRIE COMPANIE</a>
                                </div>
                            </div>
                            <div class="number-info">
                                <span class="number">{{ dataStatus ? dataStatus.solicitari : 0 }}</span>
                                <div class="flex flex-column flex-start">
                                    <p>Solicitări</p>
                                    <p>transmise</p>
                                </div>
                            </div>
                        </div>
                        <div class="flex space-between align-flex-end mobileColumn">
                            <div class="flex-column">
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    name="nume"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-sm="3"
                                        label-cols-lg="3"
                                        content-cols-sm
                                        content-cols-lg="9"
                                        label="Nume"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="form.name"
                                            type="text"
                                            name="message"
                                            :state="errors.length > 0 ? false : null"
                                        ></b-form-input>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    name="companie"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-sm="3"
                                        label-cols-lg="3"
                                        content-cols-sm
                                        content-cols-lg="9"
                                        label="Companie"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="form.company"
                                            type="text"
                                            name="message"
                                            :state="errors.length > 0 ? false : null"
                                        ></b-form-input>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    name="e-mail"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-sm="3"
                                        label-cols-lg="3"
                                        content-cols-sm
                                        content-cols-lg="9"
                                        label="E-mail"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="form.email"
                                            type="text"
                                            name="message"
                                            :state="errors.length > 0 ? false : null"
                                        ></b-form-input>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    name="telefon"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-sm="3"
                                        label-cols-lg="3"
                                        content-cols-sm
                                        content-cols-lg="9"
                                        label="Telefon"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="form.phone"
                                            type="text"
                                            name="message"
                                            :state="errors.length > 0 ? false : null"
                                        ></b-form-input>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    name="judet"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-sm="3"
                                        label-cols-lg="3"
                                        content-cols-sm
                                        content-cols-lg="9"
                                        label="Judet"
                                    >
                                        <v-select
                                            v-model="form.county"
                                            dir="ltr"
                                            :options="getCounties"
                                            label="title"
                                            :reduce="(option) => option.value"
                                            input-id="tags"
                                            class="customSelect"
                                        ></v-select>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                            </div>
                            <div class="flex-column">
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    name="CUI"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-sm="3"
                                        label-cols-lg="3"
                                        content-cols-sm
                                        content-cols-lg="9"
                                        label="CUI"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="form.business_id"
                                            type="text"
                                            name="message"
                                            :state="errors.length > 0 ? false : null"
                                        ></b-form-input>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    name="punctaj"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-sm="3"
                                        label-cols-lg="3"
                                        content-cols-sm
                                        content-cols-lg="9"
                                        label="Punctaj"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="form.score"
                                            type="text"
                                            name="message"
                                            :state="errors.length > 0 ? false : null"
                                        ></b-form-input>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    name="mesaj"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-sm="3"
                                        label-cols-lg="3"
                                        content-cols-sm
                                        content-cols-lg="9"
                                        label="Mesaj"
                                    >
                                        <b-form-textarea
                                            id="name"
                                            v-model="form.message"
                                            name="message"
                                            rows="4"
                                            placeholder="Câteva cuvinte despre investitia vizată prin proiect"
                                            :state="errors.length > 0 ? false : null"
                                        ></b-form-textarea>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                            </div>
                            <div class="flex-column smaller-column align-items-end space-between">
                                <img src="@/assets/images/M3/M3Sketch/companie-verificata.png">
                                <p class="gray-small-text">
                                    <a href="https://smis.ro/finantari/cauta-consultant" target="_blank">vezi firmele</a>
                                    <span>/</span>
                                    <a href="https://smis.ro/finantari/cauta-consultant" target="_blank">înscrie firmă consultanță</a>
                                </p>

                                <div class="button-purple-smaller" :class="lockedButton ? 'disabled-button' : ''" @click="submitForm($event)">Trimite solicitarea ta <br> către <strong>{{ dataStatus ? dataStatus.consultanti : 0 }} companii de consultanță</strong> verificate <strong>Smis<sup style="font-size: 7px;">®</sup></strong></div>
                            </div>
                        </div>
                    </b-form>
                </validation-observer>
            </div>
            <div class="flex space-between buttons">
                <div class="button-purple" @click="$emit('addM3Company')">Scrie proiectul tău</div>
                <div class="white-border-button consultant-button" :class="consultantForm ?'consultant-color':''" @click="toggleConsultant()">Caută un consultant</div>
                <div class="white-border-button" @click="$emit('backCuiInput')">Verifică altă firmă</div>
                <div class="white-border-button" @click="$emit('hideTempModal');onHide($event)">Închide acest mesaj</div>
            </div>
            <p class="info-bottom-text">
                Aplicația POCSketch® poate fi utilizată gratuit pentru o perioadă de 5 zile. Pentru utilizarea tuturor funcțiilor este necesară achiziția unei licențe. Momentan aplicația este dezvoltată în baza ghidului solicitantului varianta consultativă și varianta draft (noiembrie). Aplicația va fi actualizată odată cu lansarea ghidului final. Pentru detalii suplimentare ne poți contacta prin e-mail la office@smis.ro
            </p>
            <div class="goodwill-promo">
                <p>
                    Dacă alegi să achiziționezi o licență <strong>POC</strong>Sketch și pe parcursul scrierii realizezi că ai nevoie de un consultant care să îți <strong>întocmească</strong> și <strong>depună</strong> proiectul, suntem alături de tine. Costul licenței POCSketch <strong class="yellow-text">va fi dedus automat</strong> din costul serviciilor de consultanță oferite de <strong>Goodwill Consulting</strong>! Astfel, orice variantă ai alege, ai garanția că nu vei pierde sumele achitate pentru licență.
                </p>
                <img src="@/assets/images/gw-alb.png" alt="" style="max-width: 125px; margin-top: 5px;">
            </div>
        </div>
    </b-modal>
</template>

<script>
    import {
        BModal,
        BForm,
        BFormGroup,
        BFormInput,
        BButton,
        BIconTrash,
        BFormTextarea,
        BFormFile,
        BIconUpload,
        BFormSelect,
        BIconCheckCircle
    } from 'bootstrap-vue';
    import {ValidationProvider, ValidationObserver} from 'vee-validate'
    import axios from '@/helpers/axios'
    import api from '@/helpers/api'
    import vSelect from 'vue-select'
    // import _ from "lodash";
    require('@/helpers/validations/validations')
    export default {
        components: {
            BModal,
            BForm,
            BFormGroup,
            BFormInput,
            BButton,
            BIconTrash,
            BFormTextarea,
            BFormFile,
            BIconUpload,
            BFormSelect,
            BIconCheckCircle,
            ValidationProvider,
            ValidationObserver,
            vSelect
        },
        props: {
            scriePopup: {
                type: Boolean,
                default: false
            },
            dataStatus: null,
            consultantShow: null,
            eligible: null,
            maxFinancing: null,
            cofinantare: null,
        },
        data() {
            return {
                consultantForm: false,
                counties: [],
                form: {
                    name: '',
                    business_id: '',
                    company: '',
                    email: '',
                    phone: '',
                    score: '',
                    message: '',
                    eligible: false,
                    county: null
                /*caen: '',
                secondary_caen: '',
                ca2019: '',
                ca2020: '',*/
                },
                showModal: null,
                lockedButton: false
            };
        },
        computed: {
            getCounties() {
                let counties = []
                Object.entries(this.counties).forEach(country => {
                    counties.push({
                        title: country[1],
                        value: country[0]
                    })
                })
                return counties;
            }
        },
        watch: {
            dataStatus: {
                handler: function () {
                    if(this.dataStatus){
                        this.form.name = this.$store.getters['auth/user'].name
                        this.form.email = this.$store.getters['auth/user'].email
                        this.form.phone = this.$store.getters['auth/user'].phone
                        this.form.business_id = this.dataStatus.cui
                        this.form.company = this.dataStatus.companie
                        this.form.score = this.dataStatus.punctaj
                        this.form.caen = this.dataStatus.caen_principal
                        this.form.secondary_caen =  this.dataStatus.caen_secundar.length
                        this.form.ca2019 = this.dataStatus.cf2019
                        this.form.ca2020 = this.dataStatus.cf2020
                        this.consultantForm = this.consultantShow
                        this.form.finantareMaxim = this.maxFinancing
                        this.form.cofinantare = this.dataStatus.cofinantare
                        this.form.m1 = this.dataStatus.m1
                        this.form.m2 = this.dataStatus.m2
                        this.form.horeca = this.dataStatus.horeca
                        this.form.imm = this.dataStatus.imm
                        this.form.statusTva = this.dataStatus.statutTVA
                        this.form.angajati2020 = this.dataStatus.angajati2020
                        this.form.angajati2019 = this.dataStatus.angajati2019
                        this.form.capital2019 = this.dataStatus.capital2019
                        this.form.capital2020 = this.dataStatus.capital2020
                    } else{
                        this.form.name = this.$store.getters['auth/user'].name
                        this.form.email = this.$store.getters['auth/user'].email
                        this.form.phone = this.$store.getters['auth/user'].phone
                        this.consultantForm = this.consultantShow
                    }
                    this.consultantForm = this.consultantShow
                    if(this.eligible)
                        this.form.eligible = this.eligible;
                },
                deep:true
            },
            scriePopup(newValue, oldValue){
                if(newValue !== oldValue){
                    this.scriePopup = newValue;
                    this.showModal = this.scriePopup;
                    this.consultantForm = this.consultantShow
                }
            },
            maxFinancing: {
                handler: function () {
                    this.form.finantareMaxim = this.maxFinancing;
                }
            },
            cofinantare: {
                handler: function () {
                    this.form.cofinantare = this.cofinantare;
                }
            }
        },
        mounted() {
            if(this.dataStatus){
                this.form.name = this.$store.getters['auth/user'].name
                this.form.email = this.$store.getters['auth/user'].email
                this.form.phone = this.$store.getters['auth/user'].phone
                this.form.business_id = this.dataStatus.cui
                this.form.company = this.dataStatus.companie
                this.form.score = this.dataStatus.punctaj
                this.form.caen = this.dataStatus.caen_principal
                this.form.secondary_caen =this.dataStatus.caen_secundar.length
                this.form.ca2019 = this.dataStatus.cf2019
                this.form.ca2020 = this.dataStatus.cf2020
                this.consultantForm = this.consultantShow
                this.form.finantareMaxim = this.maxFinancing
                this.form.cofinantare = this.dataStatus.cofinantare
                this.form.m1 = this.dataStatus.m1
                this.form.m2 = this.dataStatus.m2
                this.form.horeca = this.dataStatus.horeca
                this.form.imm = this.dataStatus.imm
                this.form.statusTva = this.dataStatus.statutTVA
                this.form.angajati2020 = this.dataStatus.angajati2020
                this.form.angajati2019 = this.dataStatus.angajati2019
                this.form.capital2019 = this.dataStatus.capital2019
                this.form.capital2020 = this.dataStatus.capital2020
            } else{
                this.form.name = this.$store.getters['auth/user'].name
                this.form.email = this.$store.getters['auth/user'].email
                this.form.phone = this.$store.getters['auth/user'].phone
                this.consultantForm = this.consultantShow
            }
            this.showModal = this.scriePopup;
            if(this.eligible)
                this.form.eligible = this.eligible;
            axios.get(api.API_ROOT + '/states/RO')
                .then( response => {
                    this.counties = response.data
                })
        },
        methods: {
            onHide(evt) {
                if ( evt && evt.trigger === "backdrop") {
                    evt.preventDefault();
                    this.$emit('hideTempModal')
                }
            },
            toggleConsultant() {
                this.consultantForm = !this.consultantForm;
            },
            submitForm(event) {
                event.preventDefault();
                this.$refs.observer.validate().then((e) => {
                    if (!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    } else {
                        this.lockedButton = true
                        let sendForm = this.form;
                        sendForm.county = this.counties[this.form.county];
                        axios.post(api.API_ENDPOINTS.m3statusPopupContact, sendForm)
                            .then((response) => {
                                if(response.status === 200) {
                                    this.$toast.success(response.data.message);
                                    this.$swal({
                                        heightAuto: false,
                                        icon: 'info',
                                        title: 'Succes! <br> Mesajul tău a fost trimis către ' + this.dataStatus.consultanti + ' companii de consultanță',
                                        confirmButtonText: 'OK',
                                        showDenyButton: false
                                    })
                                    this.lockedButton = false
                                    this.form.message = ''
                                }
                                else {
                                    this.$swal({
                                        heightAuto: false,
                                        icon: 'info',
                                        title: response.data.message,
                                        confirmButtonText: 'OK',
                                        showDenyButton: false
                                    })
                                }

                            })
                            .catch(xhr => {
                                if (xhr.response.status === 422) {
                                    this.errors.record(xhr.response.data.errors);
                                }
                                this.$toast.error(xhr.response.data.message);
                            })
                            .finally(() => {
                                this.$emit('hideTempModal')
                                this.onHide()
                            })
                    }
                })
            }
        },
    };
</script>

<style scoped>
.goodwill-promo{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
    border-radius: 4px;
    border: 1px solid #fff;
    margin-top: 15px;
}
.goodwill-promo p{
    font-size: 14px;
    text-align: left !important;
}
.yellow-text{
    color: #C97706;
}
.custom-modal-class {
    overflow: visible!important;
}
.full-width {
    width: 100%;
}

.modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    min-height: 600px;
}

.modal-body >>> .modal-header span {
    font-size: 22px;
    font-weight: 700;
    color: #fff;
}
.flex-start{
    align-items: flex-start;
}
.flex-column{
    flex-direction: column;
    display: flex;
}
.modal-body >>> .modal-header {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 0;
    position: relative;
}
.number-info{
    text-align: left;
    display: flex;
    align-items: flex-end;
    margin-bottom: 15px;
}
.number-info:first-child{
    margin-right: 30px;
}
.number-info p{
    margin-top: 0 !important;
    margin-left: 10px;
}
.number-info a{
    margin-top: 0 !important;
    margin-bottom: 6px !important;
    margin-left: 10px;
}
.number-info p:last-child{
    margin-top: 0 !important;
    margin-bottom: 6px !important;
    margin-left: 10px;
}
a{
    font-size: 12px;
    text-align: right;
}
.modal-body p, .modal-body a {
    color: #fff;
    text-align: center;
    margin-top: 15px;
}

.close-button {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 11px;
    line-height: 1;
    font-weight: 600;
    color: #000;
    background: #fff;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.modal-header h2 {
    font-size: 31px;
    color: #fff;
    font-weight: 600;
}

.modal-header h3 {
    font-size: 16px;
    color: #fff;
    font-weight: 600;
    margin: 25px 0;
}
.no-send{
    opacity: 0.7;
    pointer-events: none;
}
.flex {
    display: flex;
}

.space-between {
    justify-content: space-between;
}

.align-items-center {
    align-items: center;
}

.sketch-info {
    width: 80%;
    margin: 60px auto 30px auto;
    align-items: center;
}

.sketch-info a:hover {
    text-decoration: none;
}

.info-sketch {
    width: 100%;
    max-width: 290px;
}

.info-sketch p {
    text-align: left;
    font-size: 16px;
    font-weight: 300;
    margin: 0;
    margin-left: 15px;
}

.number {
    font-size: 65px;
    font-weight: 500;
    background: -webkit-linear-gradient(#ce278f, #9b54d3);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    line-height: 1;
}

.buttons {
    width: 80%;
    margin: 20px 0 40px 0;
}

.button-purple {
    background: linear-gradient(to bottom, #ce278f, #9b54d3);
    color: #fff;
    font-size: 16px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 230px;
    min-height: 45px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    transition: 0.3s;
}
.button-purple-smaller{
    background: linear-gradient(to bottom, #ce278f, #9b54d3);
    color: #fff;
    font-size: 12px;
    text-align: center;
    padding: 9px 0;
    width: 100%;
    max-width: 230px;
    min-height: 45px;
    border-radius: 4px;
    cursor: pointer;
    transition: 0.3s;
    margin-bottom: 1rem;
}
.purple-text{
    font-weight: 700;
    background: linear-gradient(to bottom, #ce278f, #9b54d3);
    background-clip: text;
    -webkit-text-fill-color: transparent;
}
.button-purple:hover {
    background: linear-gradient(to bottom, #9b54d3, #ce278f);
}

.white-border-button {
    color: #fff;
    font-size: 16px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 230px;
    border: 1px solid #fff;
    min-height: 45px;
    border-radius: 4px;
    cursor: pointer;
    transition: 0.3s;
}

.white-border-button:hover {
    background: #fff;
    color: #000;
    transition: 0.3s;
}

.consultant-button:hover {
    background: linear-gradient(to bottom, #3c2432, #28a3b6, #4db678) !important;
    color: #fff !important;
    border: none !important;
    transition: 0.3s;
}
.consultant-color{
    background: linear-gradient(to bottom, #3c2432, #28a3b6, #4db678) !important;
    border: none !important;
}

.info-bottom-text {
    font-size: 12px;
    font-weight: 600;
}

/* CONSULTANT FORM */
.text-danger{
    position: absolute;
    white-space: pre;
}
.consultant-form {
    width: 80%;
    margin: 0 auto;
}

.align-left {
    text-align: left !important;
    align-items: flex-start !important;
}
.form-group >>> legend{
    font-size: 16px;
    opacity: 0.7;
    margin: 0;
    padding: 5px;
    color: #fff;
}
.form-group >>> .form-row{
    margin-bottom: 2.5px;
}
.form-group >>> input{
    font-size: 12px;
    color: #fff;
    background: transparent;
    border-color: #fff;
}
.form-control.is-invalid{
    border-color: #dc3545 !important;
}
.form-group >>> input::placeholder{
    font-size: 12px;
    color: #fff;
}
.form-group >>> textarea::placeholder{
    font-size: 12px;
    color: #fff;
}
.form-group >>> textarea{
    font-size: 12px;
    color: #fff;
    background: transparent;
    border-color: #fff;
}
.flex-column{
    width: 100%;
    max-width: 404px;
}
.smaller-column{
    max-width: 280px !important;
}
.align-end{
    text-align: right;
}
.align-end span{
    font-weight: 600 !important;
}
.smaller-column p, .smaller-column a{
    margin: 0;
    text-align: right;
}
.smaller-column .button-purple{
    margin-bottom: 1.3rem;
    min-height: 86px;
    max-width: 230px;
}
.align-flex-end{
    align-items: flex-end;
}
.gray-small-text{
    margin-bottom: 20px !important;
    margin-top: 10px !important;
}
.gray-small-text a, .gray-small-text span{
    font-size: 11px;
    color: #5a5a5a;
}
.gray-small-text span{
    margin: 0 5px;
}
.v-select >>> .vs__dropdown-toggle {
    margin-bottom: 0;
    background: transparent;
    padding: 3px 10px;
    border: 1px solid #fff;
    min-height: 32px;
    z-index: 9999;
}
.v-select >>> input{
    border: none;
}
.v-select >>> .vs__selected{
    margin: 0;
}
.v-select >>> .vs__selected, .v-select >>> .vs__open-indicator {
    color: #fff;
    fill: #fff;
    font-size: 15px;
}

.v-select >>> .vs__search::placeholder {
    color: #fff;
}
.disabled-button{
    opacity: 0.7;
    pointer-events: none;
}
@media (max-width: 1280px){
    .white-border-button{
        max-width: 170px;
    }
    .flex-column{
        max-width: 260px;
    }
}
@media (max-width: 1100px){
    .mobileColumn{
        flex-direction: column;
    }
    .flex-column, .smaller-column, .button-purple-smaller{
        max-width: 100% !important;
    }
    .align-items-end{
        align-items: center !important;
    }
}
@media screen and (max-width: 890px){
  .sketch-info {
    width: 100%;
    margin: 30px auto 20px auto;
  }
  .info-sketch {
    width: 33%;
    margin: 0!important;
  }
  .buttons {
    width: 100%;
  }
}

@media screen and (max-width: 550px){
  .consultant-form {
    width: 100%;
  }
  .mobile-column {
    flex-direction: column;
  }
  .white-border-button,
  .button-purple{
    font-size: 12px;
  }
  .modal-header h2{
    font-size: 24px;
  }
  .number {
    font-size: 45px;
  }
  .custom-modal-class {
    padding: 1rem 0;
  }
  .custom-modal-class .info-bottom-text{
    padding-bottom: 20px;
    text-align: justify;
    display: block;
  }
  .flex.buttons {
    flex-direction: column;
    margin-bottom: 20px;
  }
  .flex.buttons >>> .button-purple,
  .flex.buttons >>> .white-border-button {
    max-width: 100%;
    margin-bottom: 10px;
  }
  .modal-content >>> .modal-body.bg-dark {
    padding: 30px 10px;
  }
  .number-info:first-child {
    margin-right: 0;
  }
}
.customSelect{
    background: transparent;
    color: white
}
.customSelect >>> option{
    color: #0c0c0c;
}
</style>
